import React from 'react';

import { Text } from './text';
import { Settings } from './settings';
import { Resources } from './resources';
import { TaskMedia } from './task-media';
import { Leaderboard } from './leaderboard';
import { ProfilePhoto } from './profile-photo';

export const ReelsTab: React.FC = () => {
  const [selected, setSelected] = React.useState<string>('Task media');

  return (
    <>
      <div
        className={'d-flex flex-column'}
        style={{
          gap: '16px'
        }}>
        <span
          style={{
            color: '#A5B7BF'
          }}>
          Select content
        </span>

        <div
          className={'d-flex gap-4 border-bottom'}
          style={{
            paddingBottom: '8px'
          }}>
          {[
            'Task media',
            'Profile photo',
            'Text',
            'Leaderboard',
            'Resources',
            'Settings'
          ].map((tab) => (
            <div
              key={tab}
              style={{
                cursor: 'pointer',
                ...(selected === tab && {
                  color: '#003A64',
                  fontWeight: 'bold',
                  paddingBottom: '5px',
                  borderBottom: '3px solid #003A64'
                })
              }}
              onClick={() => setSelected(tab)}>
              {tab}
            </div>
          ))}
        </div>
      </div>

      {selected === 'Task media' && <TaskMedia />}
      {selected === 'Profile photo' && <ProfilePhoto />}
      {selected === 'Text' && <Text />}
      {selected === 'Leaderboard' && <Leaderboard />}
      {selected === 'Resources' && <Resources />}
      {selected === 'Settings' && <Settings />}
    </>
  );
};
